export default "<full-calendar\n  #calendar\n  [options]=\"calendarOptions\"\n>\n</full-calendar>\n";